import { render, staticRenderFns } from "./datatable-loader.vue?vue&type=template&id=d8b04c3e&lang=pug"
import script from "./datatable-loader.vue?vue&type=script&lang=js"
export * from "./datatable-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports